<div *ngrxLet="pathTestInfo$ as pathTestInfo" >
    <table id="top-table">
        <tr class="title-path">
            <td *ngIf="pathTestInfo.type === 'path test'">Test</td>
            <td *ngIf="pathTestInfo.type === 'drive test'">Drive Test</td>
            <td class="px-1">-</td>
            <td>{{pathTestInfo.stage}}</td>
            <td class="px-1">-</td>
            <td role="button" (click)="onShowBuilding(pathTestInfo.buildingId)" *ngIf="pathTestInfo.type === 'path test'">{{pathTestInfo.buildingId}}</td>
            <td role="button" (click)="onShowRoute(pathTestInfo.routeId)" *ngIf="pathTestInfo.type === 'drive test'">{{pathTestInfo.routeId}}</td>
            <td class="px-1" *ngIf="pathTestInfo.type === 'path test'">-</td>
            <td role="button" (click)="onShowPath(pathTestInfo.pathId,pathTestInfo.buildingId)" *ngIf="pathTestInfo.type === 'path test'">{{pathTestInfo.pathId}}</td>
            <ng-container *ngIf="pathTestInfo.cycle && pathTestInfo.type === 'path test'">
                <td class="px-1">-</td>
                <td>{{pathTestInfo.cycle}}</td>
            </ng-container>
            <!--
            <ng-container *ngIf="pathTestInfo.testOrder > 0">
                <td class="px-1">-</td>
                <td>{{pathTestInfo.testOrder}}</td>
            </ng-container>
            -->
        </tr>
        <tr class="text-muted small font-italic">
            <td colspan=4></td>
            <td colspan=2 *ngIf="pathTestInfo.type === 'path test'">Building</td>
            <td colspan=2 *ngIf="pathTestInfo.type === 'drive test'">Route</td>
            <td colspan=2 *ngIf="pathTestInfo.type === 'path test'">Path</td>
            <td *ngIf="pathTestInfo.cycle && pathTestInfo.type === 'path test'" colspan=2>Cycle</td>
            <!--
            <td *ngIf="pathTestInfo.testOrder > 0" colspan=2>Test Order</td>
            -->
        </tr>
    </table>
</div>

